export const BBC_LOGO_URL =
  "/logo.png";
